import { render, staticRenderFns } from "./InvestmentComparables.vue?vue&type=template&id=ffd6c312"
import script from "./InvestmentComparables.vue?vue&type=script&lang=js"
export * from "./InvestmentComparables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports